import Vue from 'vue'
import Router from 'vue-router'
import { BackToLogin, BackToDashboard } from './middlewares/middlewares'
/* Global Components */
/* -----Offset Heading----- */
import OffsetHeading from '@/components/custom-components/OffsetHeading'
Vue.component('offset-heading', OffsetHeading)
Vue.component('offset-block', () => import('@/components/custom-components/OffsetBlock'))
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/clover-response/', //:id
      component: () => import('@/views/Payments/CloverResponse.vue'),
      name: 'CloverResponse',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: false,
          name: 'Clover Response',
        }
      }
    },
    {
      path: '/clover-response-gr8table/', //:id
      component: () => import('@/views/Payments/CloverResponseGr8.vue'),
      name: 'CloverResponse',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: false,
          name: 'Clover Response',
        }
      }
    },
    {
      path: '/locations',
      component: () => import('@/views/Locations/locations.vue'),
      name: 'Locations',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Locations',
          icon: 'place'
        }
      }
    },
    {
      path: '/location-groups',
      component: () => import('@/views/LocationGroups/LocationGroups.vue'),
      name: 'Location Group',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Location Group',
          icon: 'location_city'
        }
      }
    },
    {
      path: '/',
      component: () => import('@/views/Login/Login.vue'),
      name: 'Login',
      meta: {
        middleware: BackToDashboard,
        nav: {
          display: false,
          name: 'Login'
        }
      }
    },
    {
      path: '/login',
      component: () => import('@/views/Login/Login.vue'),
      meta: {
        middleware: BackToDashboard,
        nav: {
          display: false,
          name: 'Login'
        }
      }
    },
    {
      path: '/profile/:id',
      component: () => import('@/views/Locations/Profile/profile.vue'),
      name: 'Profile',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: false,
          name: 'Profile'
        }
      },
      children: [{
        path: 'store-info',
        component: () => import('@/views/Locations/Profile/storeInfo.vue'),
        name: 'Profile_Store_Information',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Information'
          }
        }
      },
      {
        path: 'store-delivery-zones',
        component: () => import('@/views/Locations/Profile/DeliveryZones/deliveryZones.vue'),
        name: 'Locations',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Settings'
          }
        }
      },
      {
        path: 'store-contact-info',
        component: () => import('@/views/Locations/Profile/contact.vue'),
        name: 'Profile_Store_Contact',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Contact Information'
          }
        }
      },
      {
        path: 'store-images',
        component: () => import('@/views/Locations/Profile/images.vue'),
        name: 'Profile_Store_Images',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Images'
          }
        }
      },
      {
        path: 'store-hours',
        component: () => import('@/views/Locations/Profile/storeHours.vue'),
        name: 'Profile_Store_Hours',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Hours'
          }
        }
      },
      {
        path: 'store-holiday-hours',
        component: () => import('@/views/Locations/Profile/HolidayHours/storeHolidayHours.vue'),
        name: 'Profile_Store_Holiday_Hours',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Holiday Hours'
          }
        }
      },
      {
        path: 'store-address',
        component: () => import('@/views/Locations/Profile/address.vue'),
        name: 'Profile_Store_Address',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Address'
          }
        }
      }, {
        path: 'store-delivery-hours',
        component: () => import('@/views/Locations/Profile/deliveryHours.vue'),
        name: 'Profile_Delivery_Hours',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Delivery Hours'
          }
        }
      },
      {
        path: 'store-settings/:index',
        component: () => import('@/views/Locations/Profile/settings.vue'),
        name: 'Profile_Store_Settings',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Store Settings'
          }
        }
      },
      {
        path: 'store-location-groups',
        component: () => import('@/views/Locations/Profile/locationGroups.vue'),
        name: 'Profile_Store_Location_Groups',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Location Groups'
          }
        }
      },
      {
        path: 'store-printers',
        component: () => import('@/views/Locations/Profile/printers.vue'),
        name: 'Profile_Store_Printers',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Location Printers'
          }
        }
      },
      {
        path: 'store-delete',
        component: () => import('@/views/Locations/Profile/DeleteStore.vue'),
        name: 'Profile_Store_Location_Delete',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Delete Location'
          }
        }
      },
      {
        path: 'clover-token-budler',
        name: 'CloverTokenGenerate',
        component: () => import('@/views/Payments/Clover.vue'),
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Clover Budler Token'
          }
        }
      },
      {
        path: 'clover-token-gr8table',
        name: 'CloverTokenGr8Generate',
        component: () => import('@/views/Payments/CloverGr8.vue'),
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Clover Gr8table Token'
          }
        }
      }]
    },

    {
      path: '/location-group-profile/:id',
      component: () => import('@/views/LocationGroups/LocationGroupProfile/LocationGroupProfile.vue'),
      name: 'Location_Group_Profile',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: false,
          name: 'Location Groups Profile'
        }
      },
      children: [{
        path: 'details',
        component: () => import('@/views/LocationGroups/LocationGroupProfile/GroupDetails.vue'),
        name: 'Location_Group_Details',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Location Group - Details'
          }
        }
      }, {
        path: 'locations',
        component: () => import('@/views/LocationGroups/LocationGroupProfile/GroupLocations.vue'),
        name: 'Location_Group_Locations',
        meta: {
          middleware: BackToLogin,
          nav: {
            display: false,
            name: 'Location Groups - Locations'
          }
        }
      }]
    },


    {
      path: '*',
      component: () => import('@/views/pageNotFound.vue'),
      name: 'Page Not Found',
      meta: {
        // middleware: BackToLogin,
      }
    }
  ]
})
export default router
